var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.setLossAccounting({ visible: true, rowIndex: _vm.scope.rowIndex, row: _vm.scope.row, column: _vm.column})}}},[_vm._v("\n  "+_vm._s(_vm.count)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }